import { Subject, Subscription } from "rxjs";
import { PlatformEvent } from "./platform-event";

const WS_TOKEN_URL = process.env.REACT_APP_WS_TOKEN_URL as string;
const WS_PINT_TIMEOUT = 10000;

export class WS {
  private socket: WebSocket | null = null;
  private pingIntervalId: NodeJS.Timer | null = null;
  private wssSubscription: Subscription | null = null;
  private abortController = new AbortController();

  constructor(
    private accessToken: string,
    public wss$: Subject<PlatformEvent>,
    public inputWss$: Subject<
      Omit<PlatformEvent, "committedAt" | "committedBy">
    >
  ) {}

  close(reason: string) {
    this.abortController.abort();
    this.socket?.close(1000, reason);
  }

  handleOpen = () => {
    if (this.socket === null) throw new Error("WebSocket instance is null");
    if (this.socket.readyState === WebSocket.OPEN) {
      this.socket.send("ping");
    }

    this.pingIntervalId = setInterval(() => {
      if (this.socket && this.socket.readyState === WebSocket.OPEN) {
        this.socket?.send("ping");
      }
    }, WS_PINT_TIMEOUT);

    this.wssSubscription = this.inputWss$.subscribe({
      next: (value) => {
        if (value === null) return;

        if (this.socket === null) throw new Error("WebSocket instance is null");

        if (this.socket.readyState === 1) {
          this.socket.send(JSON.stringify(value));
        }
      },
    });
  };

  handleClose = (event: any) => {
    if (event.code === 1000) return;
    setTimeout(() => this.connnect(), 1000);
  };

  handleMessage = (event: MessageEvent) => {
    // ignore ping-pong messages
    if (event.data === "pong") return;

    this.wss$.next(JSON.parse(event.data as string) as PlatformEvent);
  };

  async connnect() {
    try {
      const res = await fetch(WS_TOKEN_URL, {
        signal: this.abortController.signal,
        headers: {
          authorization: `Bearer ${this.accessToken}`,
        },
      });
      const { token } = await res.json();
      this.socket = new WebSocket(
        `${process.env.REACT_APP_WS_BASE_URL}/${token}`
      );
      this.socket.onerror = (err) => {
        console.error("WebSocket error:", err);
      };
      this.socket.addEventListener("open", this.handleOpen);
      this.socket.addEventListener("close", this.handleClose);
      this.socket.addEventListener("message", this.handleMessage);
    } catch (e) {
      if (this.socket) {
        this.socket.removeEventListener("open", this.handleOpen);
        this.socket.removeEventListener("close", this.handleClose);
        this.socket.removeEventListener("message", this.handleMessage);
      }
      if (this.pingIntervalId) {
        clearInterval(this.pingIntervalId);
      }
      if (this.wssSubscription) {
        this.wssSubscription.unsubscribe();
      }
      setTimeout(() => this.connnect(), 1000);
    }
  }
}
